import { z } from "zod";

import { DatabaseUser } from "./DatabaseUser";

export const DatabaseAuditRecord = z.object({
  createdBy: DatabaseUser,
  createdDate: z.string(),
  modifiedBy: DatabaseUser,
  modifiedDate: z.string(),
});

export type DatabaseAuditRecord = z.infer<typeof DatabaseAuditRecord>;
